/* eslint-disable no-nested-ternary */
/* eslint-disable indent */

// Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { components } from 'react-select';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';

// Components

// Actions
import {
    updateCommProfileRequest,
    updateCommProfileError,
} from '../../containers/CommProfile/redux/commProfile.actions';

// Constant
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import { getRoleStatusOptions } from '../../utils/helperMethods';

// Validator
import validate from './validator';
import { FormElems, CustomSelect, Alert } from '..';

// Styles
import './editViewComm.scss';

const allOption = [{ value: 'all', label: 'All Merchants', checked: false }];
const versionData = [
    {
        name: '1.0',
        value: '1.0',
    },
    {
        name: '2.0',
        value: '2.0',
    },
    {
        name: '3.0',
        value: '3.0',
    },
     {
        name: '4.0',
        value: '4.0',
    },
     {
        name: '5.0',
        value: '5.0',
    },
    
];

const ValueContainer = ({ children, ...props }) => {
    const { getValue, hasValue } = props;
    const newChildren = [...children];
    const nbValues = getValue().filter(item => item.value !== 'all').length;
    newChildren[0] = `${nbValues} Merchants Selected`;

    if (!hasValue) {
        return (
            <components.ValueContainer {...props}>
                {children}
            </components.ValueContainer>
        );
    }
    return (
        <components.ValueContainer {...props}>
            {newChildren}
        </components.ValueContainer>
    );
};

const Option = props => {
    const { data, isSelected } = props;
    data.checked = isSelected;
    const dataOptions = [data];
    return (
        <components.Option {...props}>
            <div className={data.value}>
                <FormElems.Checkbox
                    name={data.value}
                    options={dataOptions || []}
                    valueField="value"
                    labelField="label"
                />
            </div>
        </components.Option>
    );
};

const renderCustomSelect = props => {
    const { input, data, ...attributes } = props;
    const handleBlur = () => input.onBlur;
    return (
        <div>
            <CustomSelect
                instanceId={input.name}
                {...input}
                {...attributes}
                value={data}
                onBlur={handleBlur}
            />
        </div>
    );
};

const formatGroupLabel = data => (
    <div className={`group-label ${data.label ? data.label : 'empty'}`}>
        <label>{data.label}</label>
    </div>
);

const EditViewComm = props => {
    const {
        closePopup,
        handleSubmit,
        actionType,
        actions,
        data,
        commData,
        formData,
        staticData,
        selectedTab,
    } = props;

    const { notificationEvents, updateCommProfile } = commData;
    const { underlyingMerchant } = staticData;

    const [selectedMerchant, setSelectedMerchant] = useState([]);
    const [merchantOptions, setMerchantOptions] = useState([]);
    const [eventOptions, setEventOptions] = useState([]);
    const [isViewOnly, setIsViewOnly] = useState(false);

    useEffect(() => {
        const isFormReadOnly = actionType === 'VIEW';
        setIsViewOnly(isFormReadOnly);
    }, [actionType]);

    useEffect(() => {
        if (updateCommProfile.isSuccess) {
            toast.info(SUCCESS_MESSAGES.UPDATE_DATA(`${selectedTab} Profile`));
            closePopup(true);
        }
        return () => {
            actions.updateCommProfileError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateCommProfile.isSuccess]);

    useEffect(() => {
        const formatEvents =
            notificationEvents &&
            notificationEvents.eventList.map(item => {
                return {
                    label: item,
                    value: item,
                };
            });
        setEventOptions(formatEvents || []);
    }, [notificationEvents]);

    useEffect(() => {
        const formatMerchant = underlyingMerchant.map(item => {
            return {
                label: item.name,
                value: item.entityCode,
                checked: false,
            };
        });
        const groupedOptions = [
            {
                label: '',
                options: allOption,
            },
            {
                label: 'Select Merchant',
                options: formatMerchant,
            },
        ];
        setMerchantOptions(groupedOptions);
    }, [underlyingMerchant]);

    useEffect(() => {
        const entities = [...data.linkedEntities];
        const merchants =
            (merchantOptions &&
                merchantOptions.length &&
                merchantOptions[1].options) ||
            [];
        let selectedMerchant = merchants
            .filter(item => entities.includes(item.value))
            .map(item => {
                return { ...item, checked: true };
            });
        if (merchants && merchants.length === selectedMerchant.length) {
            const allOptionCopy = [...allOption];
            allOptionCopy[0].checked = true;
            selectedMerchant = [...selectedMerchant, ...allOptionCopy];
        }
        setSelectedMerchant(selectedMerchant || []);
    }, [data.linkedEntities, merchantOptions]);

    const onCancel = (onSuccess, entityType) => {
        closePopup(onSuccess, entityType);
    };

    const getAllSelectedMerchant = allMerchantList => {
        const merchantList = allMerchantList[1];
        if (merchantList) {
            return [...allOption, ...merchantList.options];
        }
        return [];
    };

    const checkIsAllRemoved = (oldState, newState) => {
        const isOldStateHaveAll = oldState.some(item => item.value === 'all');
        const isNewStateHaveAll = newState.some(item => item.value === 'all');
        return isOldStateHaveAll !== isNewStateHaveAll;
    };

    const isAllClicked = (oldState, newState) => {
        const isOldStateHaveAll = oldState.some(item => item.value === 'all');
        const isNewStateHaveAll = newState.some(item => item.value === 'all');
        return isOldStateHaveAll === false && isNewStateHaveAll === true;
    };

    const handleMerchantSelect = value => {
        const isAllRemoved = checkIsAllRemoved(selectedMerchant, value);

        if (isAllClicked(selectedMerchant, value)) {
            const allMerchants = getAllSelectedMerchant(merchantOptions);
            setSelectedMerchant(allMerchants);
        } else if (isAllRemoved) {
            setSelectedMerchant([]);
        } else {
            const selectedValue = value.filter(item => item.value !== 'all');
            if (selectedValue.length === merchantOptions[1].options.length) {
                setSelectedMerchant([...allOption, ...value]);
            } else {
                setSelectedMerchant(selectedValue);
            }
        }
    };

    const handleEdit = event => {
        event.preventDefault();
        setIsViewOnly(false);
    };

    const filteredOptions = selectedValues => {
        return (
            selectedValues &&
            selectedValues.filter(item => item.value !== 'all')
        );
    };

    const formatStatus = status => {
        if (status === 'ACTIVE') {
            return true;
        }
        return false;
    };

    /**
     * Method to handle form submit values for Add Comm Profile
     * @param {object} values
     * @returns {null}
     */
    const handleFormSubmit = values => {
        const request = {
            entityCodes:
                selectedMerchant &&
                selectedMerchant
                    .filter(item => item.value !== 'all')
                    .map(item => item.value),
            profile: {
                comments: values.remarks,
                eventsList: values.eventsList,
                identifier: values.identifier,
                status: formatStatus(values.status),
                type: selectedTab,
                version: values.version
            },
        };
        actions.updateCommProfileRequest(request);
    };

    const getSelectedVersion = () => {
        let filteredVersionData = versionData.filter(item => item.value === data.version);
        return filteredVersionData;
    }

    const versionComponent = isViewMode => {
        if (isViewMode) {
            return (
                <div className="form-field checkbox-wrap disabled">
                    <p className="label">VERSION</p>
                    <Field
                        customClass="eventCheckBox"
                        name="version"
                        options={getSelectedVersion()}
                        labelField="name"
                        valueField="value"
                        component={FormElems.Checkbox}
                        isDisabled={true}
                    />
                </div>
            );
        }
        return (
            <div className="form-field">
                <p className="label">VERSION</p>
                <Field
                    name="version"
                    placeholder="Select Version"
                    id="version"
                    data={versionData}
                    labelField="name"
                    valueField="value"
                    component={FormElems.Select}
                    label="Select Version"
                />
            </div>
        );
    };

    return (
        <form className="add-comm-form edit-comm-form">
            {updateCommProfile.error && updateCommProfile.error.errorMessage ? (
                <Alert customClass="error-msg">
                    {updateCommProfile.error.errorMessage}
                </Alert>
            ) : null}
            <div className="form-section">
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    <div className="lastupdate-status">
                        {data.updatedBy && (
                            <>
                                Last Edit : <strong>{data.updatedBy}</strong>,{' '}
                                {moment(data.updatedOn, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.updatedOn, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.updatedOn}
                            </>
                        )}
                        {!data.updatedBy && (
                            <>
                                Created By : <strong>{data.createdBy}</strong>,{' '}
                                {moment(data.createdOn, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.createdOn, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.createdOn}
                            </>
                        )}
                    </div>
                    {isViewOnly ? (
                        <>
                            <div className={`status ${data.status}`}>
                                {data.status}
                            </div>
                        </>
                    ) : (
                        <>
                            <Field
                                name="status"
                                options={getRoleStatusOptions()}
                                defaultSelected={formData.values.status.toUpperCase()}
                                valueField="value"
                                labelField="label"
                                component={FormElems.Radio}
                                isDisabled={isViewOnly}
                                placeholder="Select Status"
                            />
                            <Field
                                wrapperClass="comment-input"
                                name="remarks"
                                type="textarea"
                                isDisabled={isViewOnly}
                                component={FormElems.TextArea}
                                placeholder="Enter Comment "
                            />
                        </>
                    )}
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Merchant Name </p>
                    {!isViewOnly ? (
                        <Field
                            name="entityCodes"
                            customClass="wrapper-select"
                            options={merchantOptions}
                            components={{ Option, ValueContainer }}
                            isMulti
                            isSearchable
                            data={selectedMerchant}
                            onChange={handleMerchantSelect}
                            closeMenuOnSelect={false}
                            component={renderCustomSelect}
                            placeholder="Select Merchant"
                            isDisabled={isViewOnly}
                            formatGroupLabel={formatGroupLabel}
                        />
                    ) : null}
                </div>
                <div
                    className={`form-field checkbox-wrap ${
                        !isViewOnly ? 'readOnly' : ''
                    } disabled`}
                >
                    <Field
                        customClass="eventCheckBox"
                        name="merchantList"
                        options={filteredOptions(selectedMerchant)}
                        valueField="value"
                        labelField="label"
                        component={FormElems.Checkbox}
                        isDisabled={true}
                    />
                </div>
            </div>
            <div className="form-section">
                <div
                    className={`form-field checkbox-wrap ${
                        isViewOnly ? 'disabled' : ''
                    }`}
                >
                    <p className="label">Select Event </p>
                    <Field
                        customClass="eventCheckBox"
                        name="eventsList"
                        options={eventOptions}
                        valueField="value"
                        labelField="label"
                        isDisabled={isViewOnly}
                        component={FormElems.Checkbox}
                    />
                </div>
            </div>
            {selectedTab === 'WEBHOOK' ? (
                <div className="form-section">
                    {versionComponent(isViewOnly)}
                </div>
            ) : null}
            <div className="form-section action">
                <FormElems.Button
                    customClass="cancel-button"
                    buttonType="secondary"
                    text="CANCEL"
                    handleClick={onCancel}
                />
                {isViewOnly ? (
                    <FormElems.Button
                        buttonType="secondary"
                        text="EDIT"
                        handleClick={handleEdit}
                    />
                ) : (
                    <FormElems.Button
                        buttonType="secondary"
                        text="UPDATE"
                        handleClick={handleSubmit(handleFormSubmit)}
                    />
                )}
            </div>
        </form>
    );
};

Option.propTypes = {
    data: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
};

ValueContainer.propTypes = {
    hasValue: PropTypes.bool,
    children: PropTypes.array,
    getValue: PropTypes.func,
};

const mapStateToProps = ({ auth, form, commData, staticData }) => ({
    auth,
    form,
    commData,
    staticData,
    formData: form['editView-mail'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        { updateCommProfileRequest, updateCommProfileError },
        dispatch
    ),
});

EditViewComm.propTypes = {
    actions: PropTypes.object,
    actionType: PropTypes.string,
    selectedTab: PropTypes.string,
    closePopup: PropTypes.func,
    commData: PropTypes.object,
    data: PropTypes.object,
    staticData: PropTypes.object,
    formData: PropTypes.object,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default compose(
    reduxForm({
        form: 'editView-mail',
        validate,
        enableReinitialize: true,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(EditViewComm);
